import { Component, Input} from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwHelpcenter
 * @module mw.components.tooltip
 *
 * @param {string} [icon='action:ic_info_24px'] If provided, will change the icon in the helpcenter link.
 *
 * @description
 * `<mw-helpcenter>` is a component used to trigger helpcenter menu.
 *
 * @usage
 * <hljs hljs-language="html">
 * <mw-helpcenter></mw-helpcenter>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-helpcenter',
    template: `
        <md-icon md-svg-src="{{ $ctrl.icon }}" class="mw-helpcenter-trigger"></md-icon>
    `
})
export class HelpdeskComponent {
    @Input('@') icon: string = 'action:ic_info_24px';

    constructor() {
        'ngInject';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/tooltip/helpdesk.tooltip.component.ts